module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_23.4c0e1d8e.jpg";